import { render, staticRenderFns } from "./mBanner.vue?vue&type=template&id=cc2facf0&scoped=true"
import script from "./mBanner.vue?vue&type=script&lang=js"
export * from "./mBanner.vue?vue&type=script&lang=js"
import style0 from "./mBanner.vue?vue&type=style&index=0&id=cc2facf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2facf0",
  null
  
)

export default component.exports